import { Skeleton, Text } from '@mantine/core';
import { IconAt, IconExternalLink } from '@tabler/icons';
import validator from 'validator';
import BookitupTextInput from '../../../Atoms/inputs/BookitupTextInput';
import { useEmailAccountingConfig } from '../../../Service/hooks/useEmailAccountingConfig';
import PanePaper from '../../../Molecules/PanePaper';

const PapierkramConfig = () => {
  const { loading, config, email, update } = useEmailAccountingConfig();
  const URL = 'https://hilfe.papierkram.de/posteingang/';

  return (
    <PanePaper title="Rechnung per E-Mail importieren">
      {loading && <Skeleton height={40} width={600} />}
      {config && (
        <>
          <BookitupTextInput
            icon={<IconAt size={20} />}
            placeholder="zufälligezeichen@posteingang.papierkram.de"
            label="E-Mail"
            defaultValue={email ?? undefined}
            type="email"
            onBlurSave={update}
            validate={validator.isEmail}
            errorMessage="Die E-Mail-Adresse ist ungültig."
            sx={{ maxWidth: 600 }}
          />
          <Text mt="xs">
            Logge dich bei Papierkram ein, gehe zu Dashboard und dann auf Posteingang. Klicke dort auf den Button E-Mails empfangen. Dort findest du dann deine individuelle E-Mail ('zufälligezeichen@posteingang.papierkram.de') für den Rechnungsimport:
            <Text variant="link" color="blue" mt={5} sx={{}}>
              <IconExternalLink style={{ marginBottom: 4, marginRight: 4 }} size={16} />
              <a target="_blank" href={URL} style={{ color: '#1D5191' }}>
                {URL}
              </a>
            </Text>
          </Text>
        </>
      )}
    </PanePaper>
  );
};

export default PapierkramConfig;
